import { useContextSelector } from 'use-context-selector';
import { UserStateContext } from '../context/UserContext/UserContext';

export const useDashboards = () => {
  return useContextSelector(UserStateContext, (v) => v?.state.dashboards);
};
